import { TFunction } from "i18next";

export type SelectOption = { value: string; title: string };

export type TranslationListType = Record<string, string | Array<string>>;

export const buildCountryList = (
  t: TFunction<"translation", undefined>,
  targetKeys: string[]
): SelectOption[] => {
  const allCountryList = t("countries.countries", {
    ns: "combined",
    returnObjects: true,
  }) as TranslationListType;
  const formattedList: SelectOption[] =
    mapTranslationsToArrayOfValues(allCountryList);
  return targetKeys.length === 0
    ? formattedList
    : formattedList.filter((item: SelectOption) =>
        targetKeys.includes(item.value)
      );
};

export const mapTranslationsToArrayOfValues = (list?: TranslationListType) => {
  if (!list) return [];
  return Object.entries(list).map(([key, value]) => ({
    value: key,
    title: Array.isArray(value) ? value[0] : value,
  }));
};
